import React from "react";

const Footer = () => {
  return (
    <div className="p-10 bg-primary-950 font-lato">
      <div className="flex flex-col lg:flex-row lg:justify-between gap-10 lg:gap-0">
        {/* Company Section */}
        <div className="company flex flex-col gap-3">
          <a className="btn btn-ghost text-xl" href="/">
            <span className="text-secondary-500">PROBI</span>
            <span className="text-primary-900 ml-[-5]">TRADING</span>
          </a>
          <div className="copyright text-white">
            Copyright © 2022 Probi Trading. <br /> ABN: 2018AD947. All rights
            reserved.
          </div>
        </div>

        {/* Contact Section */}
        <div className="contact flex flex-col gap-3 text-white">
          <h2 className="font-bold text-lg text-secondary-500">COMPANY</h2>
          <a href="/">About Us</a>
          <a href="/">Meet Our Team</a>
          <a href="/">Advisors</a>
          <label htmlFor="contacts" className="text-white">
            Select Contact:
          </label>
          <select
            name="contacts"
            id="contacts"
            className="bg-primary-950 text-white p-2 rounded-md"
          >
            <option value="support" selected>
              Customer Support
            </option>
            <option value="sales">Sales Inquiry</option>
            <option value="partnerships">Partnerships</option>
          </select>
        </div>

        {/* Legal Section */}
        <div className="legal flex flex-col gap-3 text-white">
          <h2 className="font-bold text-lg text-secondary-500">LEGAL</h2>
          <a href="/">Terms and Conditions</a>
          <a href="/">Privacy Policy</a>
          <a href="/">Terms of Sales</a>
          <a href="/">Whitepaper</a>
        </div>

        {/* Quick Links Section */}
        <div className="quick-links flex flex-col gap-3 text-white">
          <h2 className="font-bold text-lg text-secondary-500">QUICK LINKS</h2>
          <a href="/">Ecosystem</a>
          <a href="/">Roadmaps</a>
          <a href="/">FAQs</a>
          <a href="/login">Login</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
